export function Header5Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 4a1 1 0 011 1v6h4V5a1 1 0 112 0v14a1 1 0 11-2 0v-6H6v6a1 1 0 11-2 0V5a1 1 0 011-1zm9.304 14.725c-.14.25-.227.46-.262.63.335.265.732.473 1.192.622.46.15.953.226 1.478.226.545 0 1.06-.11 1.545-.33.485-.22.88-.55 1.185-.99.305-.445.457-1 .457-1.665 0-.52-.12-.978-.36-1.373a2.454 2.454 0 00-.967-.923 2.851 2.851 0 00-1.395-.337c-.325 0-.65.047-.975.142.015-.145.027-.282.037-.412l.045-.765c0-.075.003-.163.008-.263h2.52c.54 0 .81-.25.81-.75 0-.09-.008-.2-.023-.33a1.674 1.674 0 00-.097-.427h-4.77l-.113.098-.225 3.907c.105.145.243.282.413.413.175.125.345.204.51.24.21-.155.425-.28.645-.375.225-.095.46-.143.705-.143.355 0 .67.115.945.345.28.23.42.58.42 1.05 0 .46-.143.813-.428 1.057-.285.24-.632.36-1.042.36-.335 0-.648-.05-.938-.15a3.58 3.58 0 01-.832-.434c-.18.13-.343.322-.488.577z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
